import { ApiEndpoints } from "./apiEndpoints";
import { fetchData } from "./apiHelpers";
import {
  AddressRow,
  InstitutionRecord,
  MedicalSpecialty,
  ProviderRecord,
  ProviderSearchData,
  ProviderSearchParams,
} from "./provider.type";

export async function searchProvidersApi(
  params: ProviderSearchParams
): Promise<ProviderSearchData> {
  const { q, limit = 20, cursor = 0, includeInstitutions = true } = params;

  const searchParams = new URLSearchParams({
    q,
    limit: String(limit),
    cursor: String(cursor),
    includeInstitutions: String(includeInstitutions),
  });

  const url = `${process.env.REACT_APP_API_URL}${
    ApiEndpoints.providerPublic + "/search"
  }?${searchParams.toString()}`;

  const request: RequestInit = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return fetchData<ProviderSearchData>(url, request);
}

export async function getProviderOrInstitutionBySlug(slug: string): Promise<{
  type: "provider" | "institution";
  record: ProviderRecord | InstitutionRecord;
  address: AddressRow | null;
  medical_specialty: MedicalSpecialty | null;
}> {
  const url = `${process.env.REACT_APP_API_URL}${
    ApiEndpoints.providerPublic + "/slug"
  }/${encodeURIComponent(slug)}`;
  const request: RequestInit = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetchData<{
    type: "provider" | "institution";
    record: ProviderRecord | InstitutionRecord;
    address: AddressRow | null;
    medical_specialty: MedicalSpecialty | null;
  }>(url, request);
}

// Fire-and-forget call to trigger server-side contact discovery if empty.
export async function triggerContactDiscovery(slug: string): Promise<void> {
  const url = `${process.env.REACT_APP_API_URL}${
    ApiEndpoints.providerPublic + "/slug"
  }/${encodeURIComponent(slug)}`;
  try {
    await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      cache: "no-store",
    });
  } catch (e) {
    // Swallow errors; this is a best-effort trigger
    console.warn("Contact discovery trigger failed:", e);
  }
}
